export default __webpack_public_path__ + "static/media/007-Grand Canyon.c595ed3a.svg";